<template>
    <ThumbBase
        class="CoursePreview"
        :image="image"
        :title="title"
        :subtitle="subtitle"
        :icon="icon"
        @click="gotoCourse()"
    >
        <LifeskillNumberTag v-if="lifeskill" slot="tags" class="lifeskillTag" :lifeskill-id="course.lifeskillNumber" />
        <div class="card">
            <div v-if="!firstActiveStep" class="journeyIconBig" />
        </div>
    </ThumbBase>
</template>

<translations>
  course: 'Course'
  course_no: 'Kurs'
  journey: 'Journey'
  journey_no: 'Reise'
  step: 'Step'
  step_no: 'Steg'
  journeyQuiz: 'journey quiz'
  journeyQuiz_no: 'reisequiz'
</translations>

<script>
import ThumbBase from './ThumbBase';
import LifeskillNumberTag from './LifeskillNumberTag';
import { mapGetters } from 'vuex';
import UpgradePopup from '@/modules/dashboard/components/UpgradePopup';

export default {
    components: { ThumbBase, LifeskillNumberTag },
    props: {
        courseId: {
            type: String,
            required: true
        },
        firstActiveJourneyId: {
            type: String
        },
        firstActiveStepId: {
            type: String
        }
    },
    computed: {
        ...mapGetters({
            getStepById: 'moduleCourse/getStepById'
        }),

        course() {
            return this.$store.state.moduleCourse.courses[this.courseId];
        },
        lifeskill() {
            return this.$store.state.moduleApp.lifeskills[this.course.lifeskillNumber];
        },
        image() {
            return (this.firstActiveStep && this.firstActiveStep.thumb) || this.course.thumb;
        },
        title() {
            return this.lifeskill
                ? this.$t(`dashboard.general.lifeskillLabels.${this.course.lifeskillNumber}`)
                : this.course.title;
        },
        subtitle() {
            return this.firstActiveStep ? this.firstActiveStep.title : this.$t('journeyQuiz');
        },
        icon() {
            if (this.firstActiveStep) {
                if (this.firstActiveStep.number === '0') {
                    return 'campfire-2';
                } else {
                    return 'steps-3';
                }
            } else {
                return 'flag-with-checkmark';
            }
        },
        firstActiveJourney() {
            return this.$store.state.moduleCourse.stepGroups[this.firstActiveJourneyId] || null;
        },
        firstActiveStep() {
            return this.$store.state.moduleCourse.steps[this.firstActiveStepId] || null;
        }
    },
    methods: {
        gotoCourse() {
            if (this.firstActiveStep) {
                const step = this.getStepById(this.firstActiveStepId);
                const isStepLocked = !this.$can('view', step);

                if (isStepLocked) {
                    this.$modal.open({
                        component: UpgradePopup,
                        target: 'app-modal'
                    });
                } else {
                    this.$router.push({
                        name: 'Course-ActivityTransition',
                        params: {
                            courseId: this.courseId,
                            stepId: this.firstActiveStepId,
                            activityName: this.firstActiveStep.activityNames[0]
                        }
                    });
                }
            } else if (this.firstActiveJourneyId) {
                this.$router.push({
                    name: 'StepGroupQuizIntroView',
                    params: {
                        courseId: this.courseId,
                        stepGroupId: this.firstActiveJourneyId
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$transitionDuration: 0.3s;

.CoursePreview {
    width: (286em / 15); // 19em;
    height: 13em;
}

// .stepLabel {
//   text-transform: capitalize;
//   flex: 1;
// }
// .stepNumber {
//   text-transform: uppercase;
// }

// .lifeskillInfo {
//   display: flex;
// }
// .lifeskillLabel {
//   // flex: 1;
// }
.lifeskillTag {
    position: absolute;
    top: 1em;
    left: 1em;
}

// .journeyIconBig {
//   position: absolute;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   background-image: url('../../../assets/images/mountain-color.svg');
//   background-position: center;
//   background-repeat: no-repeat;
//   background-size: 30%;
// }
</style>
